import ThemeSwitcher from "./ThemeSwitcher";
import withThemeChange from "./withThemeChange";

export default withThemeChange(ThemeSwitcher);
